import {tns} from "tiny-slider/src/tiny-slider.module";

if (document.querySelector('.slide-wrapper')) {

    var slider = tns({
        container: ".slide-wrapper",
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 1
            }
        },
        autoplay: true,
        autoplayTimeout: 15000,
        mouseDrag: true,
        loop: false,
        autoplayHoverPause: true,
        autoplayButtonOutput: false,
        nav: false,
        autoplayButton: false,
        controls: false
    });


    if (document.querySelector('.prev')) {
        document.querySelector('.prev').onclick = function () {
            slider.goTo('prev');
        };
    }

    if (document.querySelector('.next')) {

        document.querySelector('.next').onclick = function () {
            slider.goTo('next');
        };
    }

}

if (document.querySelector('.slide-wrapper-clients')) {

    var slider2 = tns({
        container: ".slide-wrapper-clients",
        responsive: {
            0: {
                items: 1
            },
            540: {
                items: 2
            },
            768: {
                items: 3
            },
            992: {
                items: 5
            }
        },
        autoplay: true,
        autoplayTimeout: 15000,
        mouseDrag: true,
        loop: true,
        autoplayHoverPause: true,
        autoplayButtonOutput: false,
        nav: false,
        autoplayButton: false,
        controls: false
    });


    if (document.querySelector('.prev-clients')) {
        document.querySelector('.prev-clients').onclick = function () {
            slider2.goTo('prev');
        };
    }

    if (document.querySelector('.next-clients')) {

        document.querySelector('.next-clients').onclick = function () {
            slider2.goTo('next');
        };
    }

}
